const cornflower = [
  '#d7dee4',
  '#adbac8',
  '#8397ac',
  '#597490',
  '#2f5174',
  '#052e58', // default
  '#042649',
  '#031f3a',
  '#02172c',
  '#020f1d',
] as const

const port = [
  '#efdede',
  '#dfbfbf',
  '#c88f8f',
  '#b05f5f',
  '#993030',
  '#810000', // default
  '#690000',
  '#510000',
  '#390000',
  '#210000',
] as const

export const colors = { cornflower, port }
